module.exports = __webpack_public_path__ + "static/media/icon-pregoes.6c486c79.svg";